<template>
  <div class="mapTable">
    <div class="header-section">
      <div class="title">
        <img src="@/img/datav-tc/title_icon.png" alt="" />
        <span>{{ item.districtName || '吴店镇' }}</span>
      </div>
      <div class="time-filter">
        <div
          :class="['filter-item', { active: timeRange === 'all' }]"
          @click="changeTimeRange('all')"
        >
          全部
        </div>
        <div
          :class="['filter-item', { active: timeRange === 'year' }]"
          @click="changeTimeRange('year')"
        >
          今年
        </div>
        <div
          :class="['filter-item', { active: timeRange === 'halfYear' }]"
          @click="changeTimeRange('halfYear')"
        >
          过去半年
        </div>
        <div
          :class="['filter-item', { active: timeRange === 'month' }]"
          @click="changeTimeRange('month')"
        >
          本月
        </div>
      </div>
    </div>
    <div id="content" class="content">
      <div class="data-table">
        <table>
          <tr class="header">
            <td>采购学校数量</td>
            <td>采购订单量</td>
            <td>采购金额（万元）</td>
            <td>联合体毛利润（万元）</td>
            <td>万象毛利润（万元）</td>
          </tr>
          <tr class="data">
            <td>{{ currentData.schoolCount }}</td>
            <td>{{ currentData.orderCount }}</td>
            <td>{{ currentData.purchaseAmount }}</td>
            <td>{{ currentData.unionProfit }}</td>
            <td>{{ currentData.wanxiangProfit }}</td>
          </tr>
        </table>
      </div>
      <div id="schoolList" class="school-list">
        <div
          v-for="c in schoolList"
          :key="c.id"
          class="school-item one-line"
          @click="toSchoolDetail(c)"
        >
          <span class="school-name">{{ c.schoolName }}</span>
          <span class="purchase-amount">{{ c.purchaseAmount }}万元</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMapTableData } from '@/api/dashboard-tc'

export default {
  name: 'DataTable',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      timeRange: 'all',
      lastScrollTop: 0,
      schoolList: [],
      data: {
        all: {
          schoolCount: 0,
          orderCount: 0,
          purchaseAmount: '0',
          unionProfit: '0',
          wanxiangProfit: '0',
        },
        year: {
          schoolCount: 0,
          orderCount: 0,
          purchaseAmount: '0',
          unionProfit: '0',
          wanxiangProfit: '0',
        },
        halfYear: {
          schoolCount: 0,
          orderCount: 0,
          purchaseAmount: '0',
          unionProfit: '0',
          wanxiangProfit: '0',
        },
        month: {
          schoolCount: 0,
          orderCount: 0,
          purchaseAmount: '0',
          unionProfit: '0',
          wanxiangProfit: '0',
        },
      },
    }
  },
  computed: {
    currentData() {
      return this.data[this.timeRange]
    },
  },
  watch: {
    timeRange() {
      this.fetchData()
    },
    item: {
      handler(newVal, oldVal) {
        const newName = newVal && newVal.districtName
        const oldName = oldVal && oldVal.districtName
        if (newName !== oldName) {
          this.fetchData()
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const districtCode = (this.item && this.item.districtCode) || '吴店镇'
        const res = await getMapTableData({ districtName: districtCode, timeRange: this.timeRange })
        if (res.code === 0) {
          this.data[this.timeRange] = {
            schoolCount: res.data.schoolCount,
            orderCount: res.data.orderCount,
            purchaseAmount: res.data.purchaseAmount,
            unionProfit: res.data.unionProfit,
            wanxiangProfit: res.data.wanxiangProfit,
          }
          this.schoolList = res.data.schoolList || []
        }
      } catch (error) {
        console.error('获取地图表格数据失败:', error)
      }
    },
    changeTimeRange(range) {
      this.timeRange = range
    },
    toSchoolDetail(item) {
      this.$emit('showSchoolDetail', { id: item.id, schoolName: item.schoolName })
    },
    onScroll(e) {
      const scrollTop = e.target.scrollTop
      if (this.lastScrollTop == 0 && scrollTop > this.lastScrollTop) {
        const elementTop = document.getElementById('schoolList').offsetTop
        const content = document.getElementById('content')
        content.scrollTo({ top: elementTop })
      }
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    },
  },
}
</script>

<style lang="scss" scoped>
.school-list {
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
  gap: 16px 24px;

  .school-item {
    flex: 0 0 calc((100% - 48px) / 3);
    min-width: 260px;
    border: 1px solid rgba(0, 192, 254, 0.3);
    padding: 12px 16px;
    font-size: 18px;
    color: #e0eafa;
    cursor: pointer;
    background: linear-gradient(135deg, rgba(0, 192, 254, 0.08) 0%, rgba(5, 13, 76, 0.4) 100%);
    transition: all 0.3s ease;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 3px;
      height: 100%;
      background: linear-gradient(180deg, #00c0fe 0%, #0066ff 100%);
      opacity: 0.6;
    }

    .school-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .purchase-amount {
      margin-left: 10px;
      white-space: nowrap;
    }

    &:hover {
      background: linear-gradient(135deg, rgba(0, 192, 254, 0.2) 0%, rgba(5, 13, 76, 0.6) 100%);
      border-color: rgba(0, 192, 254, 0.6);
      color: #66ffff;
      transform: translateX(4px);

      &::before {
        opacity: 1;
      }
    }
  }
}

.mapTable {
  height: 100%;
  box-sizing: border-box;
  padding: 24px 30px;

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 26px;

    .title {
      width: 550px;
      position: relative;
      font-size: 26px;
      color: #ecf8ff;
      display: flex;
      align-items: center;

      img {
        margin-right: 3px;
      }
    }

    .time-filter {
      display: flex;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 20px;
      border: 1px solid rgba(0, 192, 254, 0.3);
      padding: 3px;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        inset: -2px;
        background: linear-gradient(90deg, #00c0fe, #126dff, #00c0fe);
        border-radius: 22px;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &:hover::before {
        opacity: 0.3;
      }

      .filter-item {
        padding: 0 16px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 13px;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(0, 192, 254, 0.2), rgba(18, 109, 255, 0.2));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        &:hover {
          color: #66ffff;

          &::before {
            opacity: 1;
          }
        }

        &.active {
          background: linear-gradient(90deg, #00c0fe 0%, #126dff 100%);
          color: #fff;
          box-shadow: 0 0 15px rgba(0, 192, 254, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2);
          font-weight: 600;

          &::before {
            display: none;
          }
        }
      }
    }
  }
}

.content {
  height: calc(100% - 80px);
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.data-table {
  width: 100%;
  margin: 0 auto;
  font-size: 19px;
  border-radius: 8px;
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: transparent;
  color: #e0eafa;
  table-layout: fixed;
  font-size: 18px;
  border-radius: 8px;
}

td {
  border: 1px solid rgba(0, 192, 254, 0.25);
  text-align: center;
  padding: 8px 10px;
  vertical-align: middle;
  line-height: 1.4;
  background: rgba(5, 13, 76, 0.6);
}

.header {
  td {
    background: linear-gradient(180deg, rgba(0, 192, 254, 0.25) 0%, rgba(0, 102, 255, 0.15) 100%);
    color: #66ffff;
    font-weight: 500;
    border-color: rgba(0, 192, 254, 0.4);
  }
}

.data {
  td {
    background: rgba(5, 13, 76, 0.4);
    color: #ecf8ff;
    transition: all 0.25s ease;
    cursor: pointer;

    &:hover {
      background: linear-gradient(180deg, rgba(0, 192, 254, 0.2) 0%, rgba(0, 102, 255, 0.1) 100%);
      color: #66ffff;
      border-color: rgba(0, 192, 254, 0.5);
    }
  }
}
</style>
